import React from 'react';
import {
  BadgeCheck,
  BriefcaseBusiness,
  Building2,
  Gamepad2,
  ShoppingBag,
  Sofa,
  Sparkles,
  Utensils,
} from 'lucide-react';

const iconMap = {
  badgeCheck: BadgeCheck,
  briefcase: BriefcaseBusiness,
  building2: Building2,
  gamepad2: Gamepad2,
  shoppingBag: ShoppingBag,
  sofa: Sofa,
  sparkles: Sparkles,
  utensils: Utensils,
};

const IndustryIcon = ({ icon, className = 'h-5 w-5' }) => {
  const Icon = iconMap[icon] || Sparkles;
  return <Icon className={className} />;
};

export default IndustryIcon;
